export default "__VITE_ASSET__boj0esyl__"